import React, { Component } from 'react';
import './Footer.scss';

class Footer extends Component {
  render() {
    return (
      <div className='footer'>
        <p>Icons by <a href='https://icons8.com' title='icons' target='_blank' rel='noreferrer'>icons8.com</a>.</p>
        <p>&copy; 2026</p>
      </div>
    )
  }
}

export default Footer;
